export const removeDuplicateLocation = (jobLocations = [], useFunctionDuplicate = true) => {
  let removeDuplicate = []
  const mappingIDs = []

  if (useFunctionDuplicate === true) {
    jobLocations.forEach((location) => {
      if (!mappingIDs.includes(location?.attributes?.location_id)) {
        removeDuplicate.push(location)
        mappingIDs.push(location?.attributes?.location_id)
      }
    })
  } else {
    removeDuplicate = jobLocations
  }

  const filterDuplicate = removeDuplicate //.filter((location) => location?.attributes.address)
  return filterDuplicate
}

export const reOrderJobLocations = (jobLocations = []) => {
  const cloneData = JSON.parse(JSON.stringify(jobLocations))
  const reOrders = []

  const findIndexHeadQuarter = cloneData.findIndex((session) => session?.attributes?.is_headquarter === true)
  if (findIndexHeadQuarter > -1) {
    reOrders.push(cloneData[findIndexHeadQuarter])
    cloneData.forEach((element, index) => {
      if (index !== findIndexHeadQuarter) {
        reOrders.push(element)
      }
    })

    return reOrders
  }

  return cloneData
}
